import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  DimensionScopeSection,
  DimensionScopeThreeSection
} from "../../../../EmissionsReports/components/ByDimensionReport/components";
import {
  getFilledCategoriesArray
} from "../../../../EmissionsReports/components/ByDimensionReport/components/DimensionScopeSection";

function ConsumptionsByDimensionModal({ modalTitle, dimensionData, isOpen, onClose }) {
  const { t } = useTranslation("translation");

  const hasNoData = () => {
    return (
      getFilledCategoriesArray(dimensionData?.directEmissions).length === 0 &&
      getFilledCategoriesArray(dimensionData?.indirectEmissions).length === 0 &&
      dimensionData?.scopeThreeEmissions?.scopeThreeTotalCo2Emissions === 0
    );
  };

  return isOpen ? <Modal isOpen={isOpen} onClose={onClose} size="6xl">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>{modalTitle} Consumptions Data</ModalHeader>
      <ModalCloseButton />

      <ModalBody>
        {dimensionData &&
          <>
            <DimensionScopeSection
              title={t("reportsPage.scope1Title")}
              data={dimensionData.directEmissions}
              hasOtherData={!hasNoData()}
            />
            <DimensionScopeSection
              title={t("reportsPage.scope2Title")}
              data={dimensionData.indirectEmissions}
              hasOtherData={!hasNoData()}
            />
            <DimensionScopeThreeSection data={dimensionData.scopeThreeEmissions} hasOtherData={!hasNoData()} />
          </>
        }
      </ModalBody>

      <ModalFooter>
        <Button variant="ghost" mr={3} onClick={onClose}>
          {t("buttons.close")}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal> : null;
}

export default ConsumptionsByDimensionModal;